import { format } from "date-fns";

import nameof from "../../../helpers/nameof";
import { Event } from "../../../../api";
import { CsvColumn } from "../../DownloadCsv";

const Columns: CsvColumn<Event>[] = [
  {
    title: "Date",
    accessor: event => format(new Date(event.start), "dd/MM/yyyy"),
  },
  {
    title: "Name",
    accessor: nameof<Event>("name"),
  },
  {
    title: "Round",
    accessor: nameof<Event>("round"),
  },
  {
    title: "Type",
    accessor: nameof<Event>("type"),
  },
  {
    title: "No. of Registrations",
    accessor: event => event.totalRegistrations,
  },
  {
    title: "No. of Attendees",
    accessor: event => event.attendance?.total,
  },
  {
    title: "Content Score",
    accessor: event => event.scores?.content,
  },
  {
    title: "Presenter Score",
    accessor: event => event.scores?.presenter,
  },
];

export default Columns;
